module.exports = __webpack_public_path__ + "static/img/line.ba1bbdb6.png";